import { BibleReader } from "./components/BibleReader";
import "./index.css";

export function App() {
  return <BibleReader />;
}

export default App;
